import React, { useEffect, useState } from "react";
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonWarning,
  FormGroup,
  InputTextblock,
  Layout,
  SelectDropDown,
} from "../../../components";
import { FiEdit, FiPlus } from "react-icons/fi";
import { ModalSosial } from "../../../components/organisms/Modal";
import { postDataPages } from "../../../service/sosialMediaService";
import { Toption, initialOption } from "../../../type/option";
import { TsosialMedia } from "../../../type/sosialMedia";
import { TusersSosialMedia } from "../../../type/usersSosialMedia";
import { showMessage } from "../../../utls/message";
import {
  getDataSosial,
  postData,
} from "../../../service/usersSosialMediaService";
import { MINIO } from "../../../data/data";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
const SosialMedia = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [sosialMediaList, setSosialMediaList] = useState<Toption[]>([]);
  const [sosialMediaOption, setSosialMediaOption] =
    useState<Toption>(initialOption);
  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [mySosialMedia, setMySosialMedia] = useState<TusersSosialMedia[]>([]);

  const { users } = useSelector((state: RootState) => state.reducer.utlsSlice);

  const getDropDownSosial = async (keyword: string) => {
    const params = {
      pageNo: 0,
      pageSize: 10,
      sortType: "DESC",
      filter: [
        {
          key: "name",
          value: keyword,
          operation: "MATCH",
          conjunction: "or",
        },
      ],
    };

    const response = await postDataPages(params);

    if (response?.code === 200 && !response?.error) {
      const data = response.data.content;

      let list: Toption[] = [];
      data.map((item: TsosialMedia, index: number) => {
        list.push({
          label: item.name,
          value: item.id?.toString() || "0",
          data: item,
        });
      });

      setSosialMediaList(list);
    }
  };

  const getMySosialMedia = async () => {
    const response = await getDataSosial();
    if (response?.code === 200 && !response.error) {
      setMySosialMedia(response.data.content || response.data || []);
    }
  };

  const onSubmit = async () => {
    if (sosialMediaOption.data.id === 0) {
      return showMessage("Sosial Media Harus Di isi", "error");
    }

    if (name.length < 4) {
      return showMessage("Sosial Media Harus Di isi", "error");
    }

    if (link.length < 4) {
      return showMessage("Sosial Media Harus Di isi", "error");
    }

    const data: any = {
      id: id > 0 ? id : undefined,
      name: name,
      link: link,
      users: {
        uniqueId: users?.uniqueId,
      },
      sosialMedia: {
        uniqueId: sosialMediaOption.data.uniqueId,
      },
      active: true,
    };

    const response = await postData(data);
    if (response?.code === 200 && !response?.error) {
      setId(0);
      setName("");
      setLink("");
      setSosialMediaOption(initialOption);
      setIsOpen(!isOpen);
      getMySosialMedia();
    }
  };

  const onView = (item: TusersSosialMedia) => {
    setId(item.id || 0);
    setName(item.name);
    setLink(item.link);
    setSosialMediaOption(
      item.sosialMedia != null
        ? {
            label: item.sosialMedia.name,
            value: item.sosialMedia.id?.toString() || "0",
            data: item.sosialMedia,
          }
        : initialOption,
    );

    setIsOpen(!isOpen);

    console.log(item);
  };

  useEffect(() => {
    getDropDownSosial("");
    getMySosialMedia();
  }, []);

  return (
    <Layout title="Sosial Media Saya" showNavBar={true} showNavigation={false}>
      <div className="mt-[4rem] relative min-h-[calc(100vh-90px)] w-full overflow-auto">
        {mySosialMedia.map((item: TusersSosialMedia, index: number) => {
          return (
            <div className="flex gap-5 justify-between bg-white p-4 rounded-md shadow-lg my-2">
              <div className="text-center overflow-hidden max-w-[50px] rounded-sm">
                <img
                  src={`${MINIO}/${item.sosialMedia.thumbnail}`}
                  className=""
                  alt={item.sosialMedia.name}
                />
              </div>
              <div className="flex flex-1 justify-between">
                <div>
                  <div className="flex gap-4">
                    <span className="block p-0 m-0 text-gray-500 font-extrabold">
                      {item.sosialMedia.name}
                    </span>
                    <button
                      onClick={() => {
                        onView(item);
                      }}
                      className=""
                    >
                      <FiEdit className="w-4" />
                    </button>
                  </div>
                  <Link to={item.link} target="_blank">
                    <span className="block p-0 m-0 text-[12px]">
                      {item.name}
                    </span>
                    <span className="block p-0 m-0 text-[10px] italic text-gray-400">
                      {item.link}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
        <div className="fixed bottom-[2rem] left-1/2 -translate-x-1/2 max-w-[480px] w-full flex justify-end px-3 z-[888] pointer-events-none">
          <button
            onClick={() => {
              setId(0);
              setName("");
              setLink("");
              setSosialMediaOption(initialOption);
              setIsOpen(!isOpen);
            }}
            className="p-3 rounded-full shadow-lg text-white bg-primary pointer-events-auto"
          >
            <FiPlus />
          </button>
        </div>
      </div>

      <ModalSosial
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(!isOpen);
        }}
      >
        <FormGroup label={"Sosial Media"}>
          <SelectDropDown
            options={sosialMediaList}
            value={sosialMediaOption}
            onChange={(e: Toption) => {
              setSosialMediaOption(e);
              setLink(e.data.link);
            }}
            onInputChange={(e) => {
              getDropDownSosial(e);
            }}
          />
        </FormGroup>
        <FormGroup label={"UserName/Name"}>
          <InputTextblock
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            placeholder="username/name"
          />
        </FormGroup>
        <FormGroup label={"Link"}>
          <InputTextblock
            value={link}
            onChange={(e) => {
              setLink(e.target.value);
            }}
            placeholder="link"
          />
        </FormGroup>
        <div className="mt-10 mb-4 pt-8 flex justify-between gap-2 border-t">
          <ButtonPrimary
            onClick={() => {
              onSubmit();
            }}
          >
            Save
          </ButtonPrimary>
          <ButtonSecondary
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            Close
          </ButtonSecondary>
        </div>
      </ModalSosial>
    </Layout>
  );
};

export default SosialMedia;
